import React, { useRef } from "react";
import clsx from "clsx";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Assets
import rectangleBackground from "../../assets/backgrounds/rectangle-blue-bg.png";
import phoneBackground from "../../assets/backgrounds/storing-evidence-bg.png";

// Hooks
import { useIsInViewportStatic } from "../../hooks/useIsInViewport";
import useSelectTransition from "../../hooks/useSelectTransition";

// Contents
import HomeSubsectionNavButtonIcon from "../HomeSubsection/HomeSubsectionNavButtonIcon";
import HomeSubsection from "../HomeSubsection/HomeSubsection";
import Text, { types } from "../Text/Text";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    position: "relative",
    width: "100%",
    marginTop: theme.spacing(3)
  },
  navPanel: {
    position: "absolute",
    right: "47vw",
    top: -70
  },
  navContent: {
    position: "relative",
    width: 654,
    height: 1099,
    [theme.breakpoints.down("md")]: {
      width: 475,
      height: 810
    }
  },
  rectangleBackground: {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 1,
    top: 330,
    left: -90,
    width: 810,
    [theme.breakpoints.up("xl")]: {
      top: 330
    },
    [theme.breakpoints.down("md")]: {
      top: 210,
      left: -70,
      width: 580
    }
  },
  navBackground: {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10,
    width: "114%",
    [theme.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  buttonList: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    top: "32%",
    left: "21%",
    zIndex: 40,
    [theme.breakpoints.down("md")]: {
      left: "18%",
      top: "27%"
    }
  },
  button: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginBottom: theme.spacing(1.2),
    padding: theme.spacing(3),
    backgroundColor: "#fff",
    boxShadow: "0px 1px 3px #0000000A",
    transition: "all .2s ease-in-out",
    width: 356,
    position: "relative"
  },
  buttonSelected: {
    boxShadow: "0px 1px 63px #0000001C",
    transform: "translateX(60px)"
  },
  arrowRight: {
    position: "absolute",
    top: theme.spacing(3),
    right: theme.spacing(3)
  },
  iconAddLight: {
    marginRight: theme.spacing(2)
  },
  contentPanel: {
    marginLeft: "48%",
    width: "50%",
    zIndex: 99,
    paddingTop: 160,
    paddingLeft: 50,
    maxHeight: 1500,
    transition: "opacity .2s ease-in-out",
    overflow: "hidden",
    opacity: 1
  },
  transitioning: {
    opacity: 0
  },
  contentImage: {
    width: 400,
    marginLeft: -35,
    [theme.breakpoints.down("md")]: {
      width: 250
    }
  }
}));

const StoringEvidence = ({ subsections }) => {
  const { selectedItem, selectedIndex, transitioning, setIndex } =
    useSelectTransition();
  const classes = useStyles();
  const ref = useRef();
  const isInViewport = useIsInViewportStatic(ref);

  const selectedSection = subsections[selectedIndex];

  return (
    <div className={classes.root}>
      <div className={classes.navPanel}>
        <div className={classes.navContent}>
          <img
            alt=""
            className={classes.rectangleBackground}
            src={rectangleBackground}
          />
          <img alt="" className={classes.navBackground} src={phoneBackground} />
          <div className={classes.buttonList} ref={ref}>
            <Text type={types.question}>Share with:</Text>
            {subsections.map(({ heading, id, icon, color }, index) => (
              <HomeSubsectionNavButtonIcon
                delay={index * 100}
                icon={icon}
                color={color}
                isInViewport={isInViewport}
                isSelected={selectedItem === index}
                key={id}
                onClick={() => setIndex(index)}
                title={heading}
              />
            ))}
          </div>
        </div>
      </div>
      <div
        className={clsx(classes.contentPanel, {
          [classes.transitioning]: transitioning || !isInViewport
        })}
      >
        <HomeSubsection
          descriptions={selectedSection.descriptions}
          heading={selectedSection.title}
          width={((selectedIndex + 1) * 100) / subsections.length}
        >
          {selectedSection.background && (
            <img
              src={selectedSection.background}
              alt=""
              className={classes.contentImage}
            />
          )}
        </HomeSubsection>
      </div>
    </div>
  );
};

export default StoringEvidence;
